export class SplFileStorageResult {
    lspSplFileStorageId: number;
    formRevisionId: number;
    formType: string;
    filePath: string;
    fileName: string;
    isDeleted: boolean;
    createDate: Date;
    createUser: string;
    changeDate: Date;
    changeUser: string;
}
